export default "__VITE_ASSET__Uau6g09a__"